export const DEFAULT_TEMPLATE_DIALOG_VALUES = {
  category: null,
  owner_id: null,
  priority: null,
  recommendations: [{ body: '', id: 1 }],
  summary: '',
  team_queue: '',
  template_name: '',
  title: ''
};

export default DEFAULT_TEMPLATE_DIALOG_VALUES;
